import { render } from "./add-executive.vue?vue&type=template&id=40bd20f2&scoped=true"
import script from "./add-executive.vue?vue&type=script&lang=js"
export * from "./add-executive.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./add-executive.vue?vue&type=style&index=1&id=40bd20f2&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bd20f2"]])

export default __exports__